module.exports = __webpack_public_path__ + "img/number4.41e3e91a.svg";